import { Component, Input, OnInit } from '@angular/core';
import { SingleSeriesChartDataItem } from '../../components/charts/charts.models';

@Component({
	selector: 'app-chart-metrics',
	templateUrl: './chart-metrics.component.html',
	styleUrls: ['./chart-metrics.component.scss']
})
export class ChartMetricsComponent implements OnInit {
	@Input() data: SingleSeriesChartDataItem[];
	@Input() label: string;

	constructor() { }

	ngOnInit(): void {
	}

	getSum() {
		return this.data ? this.data?.reduce((sum, dataItem) => sum += dataItem.value, 0).toLocaleString() : "0";
	}
}
